import React from 'react';
import iconhome from '../../../img/admin/icon-home.png';
import arrImage from '../../../img/admin/arr.png';

function Header({varTitle,varDirection}){
  return (
    <div className="tit">
      <div className="title">{varTitle}</div>
      <div className="path">
        <img src={iconhome} alt=""/>
        HOME<img src={arrImage} alt=""/>{varDirection}<img src={arrImage} alt=""/>{varTitle}
      </div>
    </div>
  );
}
export default Header;